// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skills-table {
  width: 100%;
}

.skills-table th {
  /* background: rgba(250, 250, 250, 1); */ /* UI improvement request from Alejandro*/
  vertical-align: middle !important;
}

.skills-table td {
  vertical-align: middle !important;
}
.skills-table-actions {
  display: grid;
  grid-gap: 10px;
  grid-auto-flow: column;
  zoom: 0.7;
}
`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/skillsForm/SkillsForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,wCAAwC,EAAE,yCAAyC;EACnF,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".skills-table {\n  width: 100%;\n}\n\n.skills-table th {\n  /* background: rgba(250, 250, 250, 1); */ /* UI improvement request from Alejandro*/\n  vertical-align: middle !important;\n}\n\n.skills-table td {\n  vertical-align: middle !important;\n}\n.skills-table-actions {\n  display: grid;\n  grid-gap: 10px;\n  grid-auto-flow: column;\n  zoom: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
